import React from "react";

const Select = ({
  options = [],
  value,
  onChange,
  className = "",
  ...props
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      className={`w-full h-10 px-3 rounded-md border border-gray-300 
        bg-white focus:outline-none focus:ring-2 focus:ring-black 
        disabled:opacity-50 ${className}`}
      {...props}
    >
      <option value="">Select an option</option>
      {options.map((opt, index) => (
        <option key={index} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default Select;
